import type { FunctionComponent, MouseEvent as ReactMouseEvent } from 'react';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { Analytics } from '@trello/atlassian-analytics';
import { Button } from '@trello/nachos/button';

import { ModelLoader } from 'app/scripts/db/model-loader';
import { CopyBoardView } from 'app/scripts/views/board/CopyBoardView';
import { PopOver } from 'app/scripts/views/lib/PopOver';

import styles from './CopyBoardViewPopover.less';

export const CopyBoardViewPopover: FunctionComponent<{
  idBoard: string;
}> = ({ idBoard }) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [boardModel, setBoardModel] = useState<any>();

  useEffect(() => {
    const getModel = async () => {
      const board = await ModelLoader.loadCurrentBoardMinimal(idBoard);
      setBoardModel(board);
    };
    getModel();
  }, [idBoard]);

  const toggle = (e: ReactMouseEvent) => {
    Analytics.sendClickedButtonEvent({
      buttonName: 'useTemplateButton',
      source: 'templateStoryPageScreen',
      containers: {
        board: { id: idBoard || '' },
      },
    });

    PopOver.toggle({
      elem: e.currentTarget,
      view: new CopyBoardView({
        model: boardModel,
        boardNameInputValue: boardModel.get('name'),
        gasSource: 'useTemplateInlineDialog',
      }),
    });
  };

  return (
    <Button appearance="primary" className={styles.button} onClick={toggle}>
      <FormattedMessage
        id="templates.templates.use-template"
        defaultMessage="Use template"
        description="A button for the user to use a template"
      />
    </Button>
  );
};
